import React, { useEffect, useState } from 'react'

//Material UI
import { Tabs, Tab, Grid, Container, AppBar } from '@mui/material'
import './WhoOwnsPropertySection.scss'

//Components
import WhoOwnsPropertyItem from './WhoOwnsPropertyItem'

const WhoOwnsPropertySection = React.memo(({ whoOwnsPropertyEntity }) => {
  const [whoOwnsPropertyData, setWhoOwnsPropertyData] = useState({})
  const value = 0

  useEffect(() => {
    setWhoOwnsPropertyData(whoOwnsPropertyEntity)
  }, [whoOwnsPropertyEntity])

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <div>{children}</div>}
      </div>
    )
  }

  return (
    <div className="who-owns-property-section">
      <AppBar elevation={0} position="static">
        <Tabs
          variant="fullWidth"
          value={value}
          centered={true}
          className="detail-tabs-container"
          aria-label="simple tabs example"
        >
          <Tab
            className="detail-tab border-tab"
            label={<h3 className="own-title">Who owns this property?</h3>}
            {...a11yProps(0)}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Container maxWidth="lg" className="who-owns">
          <Grid container spacing={1}>
            <Grid size={12}></Grid>
            {whoOwnsPropertyData && whoOwnsPropertyData.length > 0 && (
              <>
                {whoOwnsPropertyData.map((item, index) => (
                  <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                    <h4>{`Owner #${index + 1}`}</h4>
                    <WhoOwnsPropertyItem whoOwnsPropertyItem={item} />
                  </Grid>
                ))}
              </>
            )}
          </Grid>
        </Container>
      </TabPanel>
    </div>
  )
})

export default WhoOwnsPropertySection
